import { render, staticRenderFns } from "./bannerSwiper.vue?vue&type=template&id=2c669951&scoped=true&"
import script from "./bannerSwiper.vue?vue&type=script&lang=js&"
export * from "./bannerSwiper.vue?vue&type=script&lang=js&"
import style0 from "./bannerSwiper.vue?vue&type=style&index=0&id=2c669951&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c669951",
  null
  
)

export default component.exports